import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'landlineNumber',
    standalone: true,
})
export class LandlineNumberPipe implements PipeTransform {
    transform(t: string): string {
        return `${t.substring(0, 4)} ${t.substring(4, 6)} ${t.substring(6, 8)} ${t.substring(8, 10)}`;
    }
}
